import { SelectOption } from "shared/components/Form/Select";
import { COLOR_GREEN, COLOR_GREY_3 } from "shared/theme/colors";
import {
  ContentBlocksModuleLayout,
  GamesModuleLayout,
  GamesOrderType,
  ModuleLayout,
  ModuleStatus,
  ModuleType,
  PromotionModuleLayout,
  StudiosModuleLayout,
} from "./types";

export const MODULE_TYPE_LABELS: Record<ModuleType, string> = {
  [ModuleType.Games]: "Games",
  [ModuleType.Studios]: "Studios",
  [ModuleType.MarqueeCards]: "Marquee cards",
  [ModuleType.ProductIframe]: "Product iframe",
  [ModuleType.ContentBlocks]: "Content Blocks",
  [ModuleType.Promotion]: "Promotion",
  [ModuleType.FavouriteGames]: "Favourite games",
  [ModuleType.RecentlyPlayed]: "Recently played",
  [ModuleType.RecentWithdrawals]: "Recent withdrawals",
  [ModuleType.TopWinners]: "Top Winners",
  [ModuleType.TopPrivacyTips]: "Top Privacy Tips",
};

export const MODULE_LAYOUT_LABELS: Record<ModuleLayout, string> = {
  [GamesModuleLayout.VerticalTiles]: "Vertical tiles",
  [GamesModuleLayout.VerticalTilesStacked]: "Vertical tiles stacked",
  [GamesModuleLayout.HorizontalTiles]: "Horizontal tiles",
  [GamesModuleLayout.HorizontalTilesStacked]: "Horizontal tiles stacked",
  [GamesModuleLayout.Top10Games]: "Top 10",
  [GamesModuleLayout.BigHorizontalTiles]: "Big Horizontal Tiles",
  [StudiosModuleLayout.HorizontalLogos]: "Horizontal logos",
  [ContentBlocksModuleLayout.ThreeCardBlock]: "Three Card Block",
  [ContentBlocksModuleLayout.TextBlock]: "Text Block",
  [ContentBlocksModuleLayout.OneCardBlock]: "One Card Block",
  [PromotionModuleLayout.GridView]: "Grid view",
  [PromotionModuleLayout.HorizontalScroll]: "Horizontal scroll",
  [PromotionModuleLayout.FeaturedCarousel]: "Featured carousel",
};

export const MODULE_STATUS_LABELS: Record<ModuleStatus, string> = {
  [ModuleStatus.Active]: "Active",
  [ModuleStatus.Draft]: "Draft",
};

export const MODULE_STATUS_COLORS: Record<ModuleStatus, string> = {
  [ModuleStatus.Active]: COLOR_GREEN,
  [ModuleStatus.Draft]: COLOR_GREY_3,
};

export const GAMES_ORDER_TYPE_LABELS: Record<GamesOrderType, string> = {
  [GamesOrderType.Random]: "Random",
  [GamesOrderType.Manual]: "Manual",
};

export const THREE_CARD_BLOCK_DESCRIPTION_LIMIT = 150;
export const TEXT_BLOCK_DESCRIPTION_LIMIT = 500;

export const moduleTypeOptionsWithoutIcon = [ModuleType.TopWinners];

export const moduleLayoutOptionsWithoutIcon = [
  PromotionModuleLayout.FeaturedCarousel,
  ContentBlocksModuleLayout.TextBlock,
];

export const gamesOrderTypeOptions: SelectOption[] = [
  {
    value: GamesOrderType.Random,
    label: GAMES_ORDER_TYPE_LABELS[GamesOrderType.Random],
  },
  {
    value: GamesOrderType.Manual,
    label: GAMES_ORDER_TYPE_LABELS[GamesOrderType.Manual],
  },
];
